export default __webpack_public_path__ + "static/media/fungus.ba12a2eb.png";